var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeferredPayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.412 4.278a2.15 2.15 0 0 0-3.019-1l-5.867 3.3-.834-1.482 5.868-3.3a3.85 3.85 0 0 1 5.406 1.791l1.006 2.265-1.553.69z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.8 7.82a2.85 2.85 0 0 1 2.85-2.85h15a2.85 2.85 0 0 1 2.85 2.85v2.6a.85.85 0 1 1-1.7 0v-2.6a1.15 1.15 0 0 0-1.15-1.15h-15A1.15 1.15 0 0 0 3.5 7.82v3.3H2.45v3.6H3.5v3.1c0 .635.515 1.15 1.15 1.15h5.7a.85.85 0 0 1 0 1.7h-5.7a2.85 2.85 0 0 1-2.85-2.85z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.35 13.45c.47 0 .85.38.85.85v1.779l1.6 1a.85.85 0 1 1-.9 1.442l-2-1.25a.85.85 0 0 1-.4-.721V14.3c0-.47.38-.85.85-.85",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.35 12.37a4.15 4.15 0 1 0 0 8.3 4.15 4.15 0 0 0 0-8.3m-5.85 4.15a5.85 5.85 0 1 1 11.7 0 5.85 5.85 0 0 1-11.7 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.25 12.92a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.45 11.12v3.6h3.8a1.8 1.8 0 0 0 0-3.6h-3.8m-.7-1.7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4.5a3.5 3.5 0 1 0 0-7z",
  clipRule: "evenodd"
}))));
export default SvgDeferredPayment;